import { render, staticRenderFns } from "./LoggedInUser.vue?vue&type=template&id=49e829a3"
import script from "./LoggedInUser.vue?vue&type=script&lang=js"
export * from "./LoggedInUser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports